<template>
  <div id="Evaluations">
    <v-app-bar class="grey lighten-3 d-md-none" fixed elevate-on-scroll>
      <v-layout justify-center align-center>
        <v-icon large color="blue darken-3">mdi-voice</v-icon>
        <span class="title blue--text text--darken-3 ml-1">
          My Evaluations</span
        >
      </v-layout>
    </v-app-bar>

    <!-- Total Evaluations Container -->
    <v-container class="pb-0 wrap">
      <v-card class="card elevation-0" flat tile>
        <v-layout row align-center justify-center>
          <v-layout column align-center>
            <span
              class="percentageValue display-3 blue__text__color font-weight-medium "
              >{{ userEvaluations.length }}</span
            >
            <p class="mt-2 grey--text ">Total Evaluations</p>
          </v-layout>
        </v-layout>
      </v-card>
    </v-container>

    <!-- My Evaluators Container -->
    <v-container mt-4 px-0 pt-0>
      <v-card flat outlined>
        <v-toolbar color="grey darken-3" dark flat>
          <v-toolbar-title>My Evaluators</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-btn
            v-if="!checkUserLoggedIn || !checkUserIsSubscribed"
            class="mr-1 elevation-0 "
            dark
            color="grey lighten-1"
            >Add Writer</v-btn
          >
          <v-btn
            v-else
            @click="showAddWriter"
            class="mr-1 pa-2 elevation-6"
            dark
            large
            color="#D49129"
            >Add Writer</v-btn
          >
        </v-toolbar>

        <v-card-text class="px-1">
          <!-- Login or Signup Card -->
          <v-card v-if="!checkUserLoggedIn" class="elevation-0">
            <v-card-text class="text-center black--text"
              >You need an active subscription to add evaluations</v-card-text
            >
            <v-card-actions>
              <v-layout justify-center>
                <v-btn
                  to="/LoginSignupPage"
                  style="width:40%"
                  class="elevation-0 mr-4"
                  color="green"
                  dark
                  @click="showCreateSubscriptionDialog = false;"
                >
                  Login
                </v-btn>
                <v-btn
                  to="/signup"
                  style="width:40%"
                  class="elevation-0"
                  color="primary"
                  @click="showCreateSubscriptionDialog = false;"
                >
                  Signup
                </v-btn>
              </v-layout>
            </v-card-actions>
          </v-card>

          <!-- Active Subscription Card -->
          <v-card v-else-if="!checkUserIsSubscribed" class="elevation-0">
            <v-card-text class="text-center black--text"
              >You need an active subscription to add evaluations</v-card-text
            >
            <v-card-actions>
              <v-layout justify-center>
                <v-btn
                  to="/myaccount"
                  block
                  class="elevation-0"
                  color="primary"
                >
                  My Account
                </v-btn>
              </v-layout>
            </v-card-actions>
          </v-card>

          <!-- User Evaluators -->
          <div v-else-if="checkUserLoggedIn && checkUserIsSubscribed">
            <v-card class="white" flat tile>
              <WriterList
                v-for="writer in userEvaluations"
                :key="writer.id"
                :writer="writer"
              />
              <v-container
                v-if="
                  userEvaluations.length === 0 &&
                    (user !== null && user !== undefined)
                "
                mt-3
                pt-2
              >
                <p
                  class=" mb-0 text-center body-1 mt-0 pt-1 grey--text text--darken-4 font-weight-light"
                >
                  You have no evaluators saved. Add a writer for your
                  evaluation.
                </p>
              </v-container>
            </v-card>
          </div>
        </v-card-text>
      </v-card>
    </v-container>

    <!-- Back Button -->
    <v-btn
      class="mr-4 ml-2  fixed elevation-0 hidden-md-and-up"
      color="red"
      fab
      rounded
      small
      @click="back"
    >
      <v-icon medium color="white">mdi-arrow-left</v-icon></v-btn
    >
  </div>
</template>

<script>
import userMixins from "@/mixins/usersmixin";
export default {
  mixins: [userMixins],
  props: ["evaluation"],
  data() {
    return {};
  },
  methods: {
    back() {
      this.$router.push("/dashboard");
    },
    showAddWriter() {
      this.$router.push("/dashboard/evaluations/addevaluationwriter");
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    userEvaluations() {
      return this.$store.getters.userEvaluations;
    }
  }
};
</script>

<style scoped>
.v-toolbar__content {
  padding-right: 0px !important;
}
a {
  text-decoration: none;
}

.card {
  border-radius: 3px;
}
#buttonShadow {
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.19);
}

.fixed {
  position: fixed;
  bottom: 0;
  right: 0;
  margin-bottom: 65px;
}

img {
  width: 50px;
  height: 50px;
}

.linkLogo {
  width: 33px;
  height: 33px;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 5px;
}

.tweetLogo {
  width: 37px;
  height: 37px;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 10px;
}
.blueHeading {
  color: #2196f3;
}

@media (max-width: 900px) {
  .wrap {
    margin-top: 8vh !important;
  }
}

.blue__text__color {
  color: #005880;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Evaluations/Evaluations.vue